import { render, staticRenderFns } from "./PagePane.vue?vue&type=template&id=20a48e2c&scoped=true&"
import script from "./PagePane.vue?vue&type=script&lang=js&"
export * from "./PagePane.vue?vue&type=script&lang=js&"
import style0 from "./PagePane.vue?vue&type=style&index=0&id=20a48e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a48e2c",
  null
  
)

export default component.exports